var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.groups),function(group,gIndex){return _c('div',{key:gIndex,staticClass:"pt-4"},[_vm._t("group-header",null,{"groupName":group}),_vm._l((_vm.groupItems(group)),function(item,iIndex){return _c('div',{key:iIndex},[_vm._t("list-item",null,{"item":item,"index":iIndex})],2)})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }